/**
 * AWS Bedrock 설정
 * 주의: 이 파일은 .gitignore에 추가하세요
 */

export const AWS_CONFIG = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID || 'AKIAJKYRNLRACLYY5TJQ',
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY || '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'
  },
  modelId: 'global.anthropic.claude-sonnet-4-5-20250929-v1:0'
}
